module.exports = __webpack_public_path__ + "img/keyboard.6b5de470.svg";